export const localStorageKeys = {
  email: 'email',
  authToken: 'auth_token',
  refreshToken: 'refresh_token',
  route: 'route'
}
